export * from "./link.module";

export * from "./link.component";
